import { Component, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  Company,
  CompanyQuery,
  CompanyService,
  CompanyOfferModel,
  CompanyOfferQuery,
  CompanyOfferService,
} from '@fgb/core';

export interface BrandDetailView {
  offer: CompanyOfferModel;
  company: Company | undefined;
}

@Component({
  selector: 'fgb-brand-detail-page',
  templateUrl: './brand-detail-page.component.html',
  styleUrls: ['./brand-detail-page.component.scss'],
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ height: '0', overflow: 'hidden', opacity: 0 }),
        animate('200ms ease-out', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: '*', overflow: 'hidden', opacity: 1 }),
        animate('200ms ease-in', style({ height: '0', opacity: 0 })),
      ]),
    ]),
  ],
})
export class BrandDetailPageComponent implements OnInit {
  viewData$: Observable<BrandDetailView | null>;
  descriptionOpen = true;
  tcsOpen = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private companyService: CompanyService,
    private companyQuery: CompanyQuery,
    private companyOfferService: CompanyOfferService,
    private companyOfferQuery: CompanyOfferQuery
  ) {}

  ngOnInit() {
    const offerId = Number(this.route.snapshot.paramMap.get('id'));

    this.companyService.fetchAllCompanies().subscribe();
    this.companyOfferService.fetchOffers(0, 0).subscribe();

    this.viewData$ = this.companyOfferQuery.selectOffer(offerId).pipe(
      switchMap((offer) => {
        if (!offer) return of(null);
        return this.companyQuery.selectCompany(offer.CompanyId).pipe(
          map((company) => ({ offer, company }))
        );
      })
    );
  }

  goBack() {
    this.router.navigate(['/brand']);
  }

  async claimOffer(offerId: number) {
    const result = await this.companyOfferService.claimOffer(offerId);
    if (result?.RedirectUrl) {
      window.open(result.RedirectUrl);
    }
  }

}
